import React, { useEffect, useState, useCallback } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { get } from "lodash";
import infoIcon from "../../../../images/ic_info.png";
import { useHistory } from "react-router-dom";
import "./CustomcssMain.css";

function AddManagerPatient(props) {
  const [EnvironmentList, setEnvironmentList] = useState([]);
  const [CharacterList, setCharacterList] = useState([]);
  const [EnvironmentId, setEnvironmentId] = React.useState("");
  const [CharacterId, setCharacterId] = React.useState("");
  const [EnvironmentImgPreview, setEnvironmentImgPreview] = React.useState("");
  const [CharacterImgPreview, setCharacterImgPreview] = React.useState("");
  const mangerId = localStorage.getItem("ManegerId");
  const [LastPatientId, setLastPatientId] = useState([]);
  const [CaseName, setCaseName] = useState("");
  const [PatientName, setPatientName] = useState("");
  const [DateOfBirth, setDateOfBirth] = useState("");
  const [Gender, setGender] = useState("");
  const [PatientRole, setPatientRole] = useState("");
  const [UserRole, setUserRole] = useState("");
  const [Address, setAddress] = useState("");
  const [Place, setPlace] = useState("");
  const [PersonalLife, setPersonalLife] = useState("");
  const [PresentingProblem, setPresentingProblem] = useState("");
  const [AboutTheCase, setAboutTheCase] = useState("");
  const [Skill1, setSkill1] = useState("");
  const [Skill2, setSkill2] = useState("");
  const [Skill3, setSkill3] = useState("");
  const [Skill4, setSkill4] = useState("");
  const [Skill5, setSkill5] = useState("");
  const [Skill6, setSkill6] = useState("");
  const [SkillDesc1, setSkillDesc1] = useState("");
  const [SkillDesc2, setSkillDesc2] = useState("");
  const [SkillDesc3, setSkillDesc3] = useState("");
  const [SkillDesc4, setSkillDesc4] = useState("");
  const [SkillDesc5, setSkillDesc5] = useState("");
  const [SkillDesc6, setSkillDesc6] = useState("");
  const [VoiceList, setVoiceList] = useState([]);
  const [VoiceId, setVoiceId] = React.useState("");

  const [prompt, setPrompt] = React.useState("");
  const [EnvBgImgList, setEnvBgImgList] = useState([]);
  const [custBgImgFile, setCustBgImgFile] = useState(null);
  const [error, setError] = useState('');
  const [selectedEnvBg, setSelectedEnvBg] = useState({
    Img_Id: 0,
    Img_Url: "",
    Img_Name: ""
  });
  const [choosedEnvBg, setChoosedEnvBg] = useState({
    Img_Id: 0,
    Img_Url: "",
    Img_Name: ""
  });

  const [isEnvGenerating, setIsEnvGenerating] = useState(false);
  const [isFinalSubmitting, setIsFinalSubmitting] = useState(false);
  const [custBgLimit, setCustBgLimit] = useState('');
  const [custBgRemaining, setCustBgRemaining] = useState('');
  const [CustEnvImgPreview, setCustEnvImgPreview] = React.useState("");
  const [generatedImages, setGeneratedImages] = useState([]);

  const navigate = useHistory();

  useEffect(() => {
    LoadPatient();
    LoadCasesLimit();
    LoadEnvironments();
    LoadCharacters();
    LoadEnvBgImages();
    LoadCustBgLimit();
    LoadCharacterVoices();

    // Function to handle browser back button navigation
    const unlisten = navigate.listen((location, action) => {
      if (action === 'POP') {
        const modalElement = document.getElementsByClassName("modal-backdrop");
        if (modalElement) {
          Array.from(modalElement).forEach(element => {
            element.style.display = 'none';
          });
        }
      }
    });

    return () => {
      unlisten();
    };

  }, [navigate]);

  const LoadPatient = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/GetLastPatientId`).then((res) => {
      const lastPatient = res.data;

      const newPatientId = parseInt(lastPatient) + 1;
      setLastPatientId(newPatientId.toString());
    }).catch((err) => {
      if (err instanceof TypeError) {
        setLastPatientId(1);
      } else
        setLastPatientId(err);
    });
  };

  const LoadCasesLimit = () => {
    const datavalue = {
      managerId: mangerId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetCasesLimit`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    // TODO: Change error message
    axios(authOptions).then((res) => {
      var casesLimitData = res.data.data;
      const casesRemaining = parseInt(casesLimitData.cases_Remaining);
      const casesLimit = parseInt(casesLimitData.cases_Limit);
      const totalCasesLimit = parseInt(casesLimitData.total_Cases_Limit);
      const limit = totalCasesLimit > 0 ? totalCasesLimit : casesLimit;

      if (limit > 0 && casesRemaining < 1) {
        Swal.fire({
          title: "Limit!",
          text: "You have reached the maximum number of cases",
          icon: "warning",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            navigate.push("/ManagerPatientList");
          }
        });
      }
    }).catch((err) => {
      console.log(err);
    });
  };

  const LoadEnvironments = () => {
    const datavalue = {
      managerId: mangerId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetEnvironmentByManager`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    axios(authOptions).then((res) => {
      setEnvironmentList(res.data.data);
    });
  };

  const LoadCharacters = () => {
    const datavalue = {
      managerId: mangerId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetCharacterByManager`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    axios(authOptions).then((res) => {
      setCharacterList(res.data.data);
    });
  };

  const LoadCharacterVoices = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/GetAllVoice`).then((res) => {
      setVoiceList(res.data);
    });
  };

  const LoadEnvBgImages = () => {
    const datavalue = {
      managerId: mangerId,
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetEnvBgImagesByManager`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      setEnvBgImgList(res.data.data);
    });
  };

  const LoadCustBgLimit = () => {
    const datavalue = {
      ManagerId: mangerId,
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetCustBgLimit`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    axios(authOptions).then((res) => {
      setCustBgLimit(res.data.data.limit);
      setCustBgRemaining(res.data.data.remaining);
    });
  }

  // Function called when Form Submitted
  const Patientsubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    // ---------------------------------------------------

    if (
      CaseName === "" ||
      PatientName === "" ||
      DateOfBirth === "" ||
      Gender === "" ||
      PatientRole === "" ||
      UserRole === "" ||
      Address === "" ||
      Place === "" ||
      PersonalLife === "" ||
      PresentingProblem === "" ||
      EnvironmentId === "" ||
      CharacterId === ""
    ) {
      if (CharacterId === "") {
        Swal.fire({
          title: "Error",
          text: "Please select at least one character.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (EnvironmentId === "") {
        Swal.fire({
          title: "Error",
          text: "Please select at least one environment.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (CaseName === "") {
        Swal.fire({
          title: "Error",
          text: "Case name is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (PatientName === "") {
        Swal.fire({
          title: "Error",
          text: "Character name is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (DateOfBirth === "") {
        Swal.fire({
          title: "Error",
          text: "Date of birth is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (Gender === "") {
        Swal.fire({
          title: "Error",
          text: "Select gender.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (PatientRole === "") {
        Swal.fire({
          title: "Error",
          text: "Character's role is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (UserRole === "") {
        Swal.fire({
          title: "Error",
          text: "User role is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (Address === "") {
        Swal.fire({
          title: "Error",
          text: "Address is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (Place === "") {
        Swal.fire({
          title: "Error",
          text: "Place is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (PersonalLife === "") {
        Swal.fire({
          title: "Error",
          text: "Personal life is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (PresentingProblem === "") {
        Swal.fire({
          title: "Error",
          text: "Case description required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
    } else {
      const datavalue = {
        User_Id: mangerId,
        Environment_Id: EnvironmentId,
        Character_Id: CharacterId,
        Case_Name: CaseName.charAt(0).toUpperCase() + CaseName.slice(1),
        Patient_Name: PatientName.charAt(0).toUpperCase() + PatientName.slice(1),
        DOB: DateOfBirth,
        Patient_Gender: Gender,
        Character_Role: PatientRole,
        User_Role: UserRole,
        Address: Address,
        Place: Place,
        Personal_Life: PersonalLife,
        Case_Description: "",
        Patient_Id: LastPatientId,
        Presenting_Problem: PresentingProblem.charAt(0).toUpperCase() + PresentingProblem.slice(1),
        About_The_Case: AboutTheCase.charAt(0).toUpperCase() + AboutTheCase.slice(1),
        Skill1: Skill1,
        SkillDesc1: SkillDesc1,
        Skill2: Skill2,
        SkillDesc2: SkillDesc2,
        Skill3: Skill3,
        SkillDesc3: SkillDesc3,
        Skill4: Skill4,
        SkillDesc4: SkillDesc4,
        Skill5: Skill5,
        SkillDesc5: SkillDesc5,
        Skill6: "",
        SkillDesc6: "",
        Voice_Id: VoiceId === "" ? "0" : VoiceId
      };


      if (choosedEnvBg.Img_Url !== "") {
        datavalue.envBgImgModel = choosedEnvBg;
      }
      formData.append('data', JSON.stringify(datavalue));

      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/AddManegerPatient`,
        // data: JSON.stringify(datavalue),
        data: formData,
        // headers: { "Content-Type": "application/json" },
        headers: {
          "Content-Type": "multipart/form-data"
        },
        // json: true,
      };

      setIsFinalSubmitting(true);

      axios(authOptions)
        .then((res) => {
          setIsFinalSubmitting(false);
          if (res.data.SuccessResult) {
            Swal.fire({
              title: "Success",
              text: res.data.SuccessResult,
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: "#1e2b38"
            }).then(function () {
              navigate.push("/ManagerPatientList");
            });
          } else if (res.data.ExpResult) {
            Swal.fire({
              title: "Error",
              text: res.data.ExpResult,
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#1e2b38"
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "Something went wrong!",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#1e2b38"
            });
          }
        })
        .catch((error) => {
          //console.log("error occur", error);
        });
    }
  };

  const handleChangeEnvironment = (event) => {
    let env_id = event.target.value
    if (env_id != "") {
      setEnvironmentId(env_id);
      var imagepath = `${process.env.REACT_APP_API_URL}/GetEnvironmentImageById?EnvironmentId=` + env_id;
      setEnvironmentImgPreview(imagepath);
      var img = document.getElementById("envImgPreview");
      img.style.visibility = "visible";
      img.style.width = "100%";
      // img.style.maxHeight = "150px";
      img.style.height = "auto";
    } else {
      setEnvironmentId("");
      var img = document.getElementById("envImgPreview");
      img.style.visibility = "hidden";
      img.style.width = "0px";
      img.style.height = "0px";
    }
  };

  const handleChangeCharacter = (event) => {
    let character_id = event.target.value
    if (character_id != "") {
      setCharacterId(character_id);
      var imagepath = `${process.env.REACT_APP_API_URL}/GetCharacterImageById?CharacterId=` + character_id;
      setCharacterImgPreview(imagepath);
      var img = document.getElementById("characterImgPreview");
      img.style.visibility = "visible";
      img.style.width = "100%";
      // img.style.maxHeight = "150px";
      img.style.height = "auto";
    } else {
      setCharacterId("");
      var img = document.getElementById("characterImgPreview");
      img.style.visibility = "hidden";
      img.style.width = "0px";
      img.style.height = "0px";
    }
  };

  const handleChangeCaseName = (event) => {
    setCaseName(event.target.value);
  };

  const handleChangePatientName = (event) => {
    setPatientName(event.target.value);
  };

  const handleChangePatientAge = (event) => {
    setDateOfBirth(event.target.value);
  };

  const handleChangeGender = (event) => {
    setGender(event.target.value);
  };

  const handleChangePatientRole = (event) => {
    setPatientRole(event.target.value);
  };

  const handleChangeUserRole = (event) => {
    setUserRole(event.target.value);
  };

  const handleChangeAddress = (event) => {
    setAddress(event.target.value);
  };

  const handleChangePlace = (event) => {
    setPlace(event.target.value);
  };

  const handleChangePersonalLife = (event) => {
    setPersonalLife(event.target.value);
  };

  const handleChangePresentingProblem = (event) => {
    setPresentingProblem(event.target.value);
  };

  const handleChangeAboutTheCase = (event) => {
    setAboutTheCase(event.target.value);
  };

  const handleChangeSkill1 = (event) => {
    setSkill1(event.target.value);
  };

  const handleChangeSkill2 = (event) => {
    setSkill2(event.target.value);
  };

  const handleChangeSkill3 = (event) => {
    setSkill3(event.target.value);
  };

  const handleChangeSkill4 = (event) => {
    setSkill4(event.target.value);
  };

  const handleChangeSkill5 = (event) => {
    setSkill5(event.target.value);
  };

  const handleChangeSkill6 = (event) => {
    setSkill6(event.target.value);
  };

  const handleChangeSkillDesc1 = (event) => {
    setSkillDesc1(event.target.value);
  };

  const handleChangeSkillDesc2 = (event) => {
    setSkillDesc2(event.target.value);
  };

  const handleChangeSkillDesc3 = (event) => {
    setSkillDesc3(event.target.value);
  };

  const handleChangeSkillDesc4 = (event) => {
    setSkillDesc4(event.target.value);
  };

  const handleChangeSkillDesc5 = (event) => {
    setSkillDesc5(event.target.value);
  };

  const handleChangeSkillDesc6 = (event) => {
    setSkillDesc6(event.target.value);
  };

  const BackFunc = () => {
    navigate.push("/ManagerPatientList");
  };


  const handleChangeVoice = (event) => {
    let id = event.target.value;

    if (id !== "") {
      setVoiceId(id);
    } else {
      setVoiceId("");
    }
  }


  const handleChangeEnvBgImgName = (event) => {
    setChoosedEnvBg((prevState) => ({
      ...prevState,          // Spread the previous state to retain the other properties
      Img_Name: event.target.value   // Update only the Img_Name property
    }));
  }

  const onCustBgImgUpload = (event) => {
    const uFile = get(event, "target.files[0]");
    if (uFile && uFile.type.startsWith('image/')) {
      const maxSize = 20 * 1024 * 1024; // 5MB

      if (uFile.size > maxSize) {
        setError('Please drop an image file less than 20MB');

        var fileUploadIcon = document.getElementById("fileUploadIcon");
        fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

        var fileUploadHeader = document.getElementById("fileUploadHeader");
        fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
      } else {
        setCustBgImgFile(uFile);
        setError('');

        var fileUploadIcon = document.getElementById("fileUploadIcon");
        fileUploadIcon.innerHTML = "<i class='fa-solid fa-circle-check'></i>";

        var fileUploadHeader = document.getElementById("fileUploadHeader");
        fileUploadHeader.innerHTML = 'File Dropped Successfully!';
      }
    } else {
      setError('Please select an image file (e.g., .jpg, .png)');

      var fileUploadIcon = document.getElementById("fileUploadIcon");
      fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

      var fileUploadHeader = document.getElementById("fileUploadHeader");
      fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
    }
  };

  const onChooseClicked = () => {
    if (selectedEnvBg.Img_Url === "") {
      setError('Please select an image');
      return;
    }

    setCustBgImgFile(null); // Clear the custom image file
    setError(''); // Clear the error message

    setCustEnvImgPreview(selectedEnvBg.Img_Url); // Set the selected image as the background image
    var img = document.getElementById("custEnvImgPreview");
    img.style.visibility = "visible";
    img.style.width = "100%";
    img.style.height = "auto";

    setChoosedEnvBg(selectedEnvBg); // Set the selected image as the choosed image
  }

  const onRemoveClicked = () => {
    setCustEnvImgPreview(''); // Clear the custom image preview
    setChoosedEnvBg({
      Img_Id: 0,
      Img_Url: "",
      Img_Name: ""
    }); // Clear the choosed image

    var img = document.getElementById("custEnvImgPreview");
    img.style.visibility = "hidden";
    img.style.width = "0px";
    img.style.height = "0px";

    var img1 = document.getElementById("img1");
    var img2 = document.getElementById("img2");
    var img3 = document.getElementById("img3");
    var img4 = document.getElementById("img4");
    img1.style.border = "1px solid #ccc";
    img2.style.border = "1px solid #ccc";
    img3.style.border = "1px solid #ccc";
    img4.style.border = "1px solid #ccc";
  }

  const onCancelClicked = () => {
    setCustEnvImgPreview(''); // Clear the custom image preview
    setSelectedEnvBg({
      Img_Id: 0,
      Img_Url: "",
      Img_Name: ""
    }); // Clear the selected image
    setChoosedEnvBg({
      Img_Id: 0,
      Img_Url: "",
      Img_Name: ""
    }); // Clear the choosed image
    setPrompt('');
    // setEnvBgImgList([]);
    setCustBgImgFile(null); // Clear the custom image file
    setError(''); // Clear the error message
    setGeneratedImages([]);

    var img = document.getElementById("custEnvImgPreview");
    img.style.visibility = "hidden";
    img.style.width = "0px";
    img.style.height = "0px";

    var img1 = document.getElementById("img1");
    var img2 = document.getElementById("img2");
    var img3 = document.getElementById("img3");
    var img4 = document.getElementById("img4");
    img1.style.border = "1px solid #ccc";
    img2.style.border = "1px solid #ccc";
    img3.style.border = "1px solid #ccc";
    img4.style.border = "1px solid #ccc";
  }

  const onUploadClicked = () => {
    if (!custBgImgFile) {
      setError('Please select an image file (e.g., .jpg, .png)');
      return;
    }

    // if (mangerId === "") {
    //   setError('Please select a portal first');
    //   return;
    // }

    let formDataSet = new FormData();
    formDataSet.append("prompt", prompt);
    formDataSet.append("img", custBgImgFile);
    formDataSet.append("portalId", "0");
    formDataSet.append("ManagerId", mangerId);
    formDataSet.append("UserRole", "Manager");

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GenerateEnvBg`,
      data: formDataSet,
      headers: { "Content-Type": "multipart/form-data" },
    };

    setError(''); // Clear the error message
    setIsEnvGenerating(true); // Show the loading animation

    axios(authOptions).then((res) => {
      setIsEnvGenerating(false); // Hide the loading animation
      if (res.data.ExpResult) {
        setError(res.data.ExpResult);
      } else if (res.data.SuccessResult) {
        var images = res.data.SuccessResult.split(","); // Split the string into an array with 4 elements
        setGeneratedImages(images);
      } else {
        setError("An Error Occured");
      }
    }).catch((error) => {
      setIsEnvGenerating(false); // Hide the loading animation
      setError('An error occured!');
      console.log("error occur", error);
    }
    );
  }

  const onDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();

    var fileUploadIcon = document.getElementById("fileUploadIcon");
    fileUploadIcon.innerHTML = "<i class='fa-solid fa-download'></i>";

    var fileUploadHeader = document.getElementById("fileUploadHeader");
    fileUploadHeader.innerHTML = 'Drop your file here!';
  };

  const onDragLeave = (e) => {
    e.preventDefault();

    var fileUploadIcon = document.getElementById("fileUploadIcon");
    fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

    var fileUploadHeader = document.getElementById("fileUploadHeader");
    fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
  };

  const removeFileButton = () => {
    setCustBgImgFile(null);
    setError('');

    var customBgImg = document.getElementById("customBgImg");
    customBgImg.value = '';


    var fileUploadIcon = document.getElementById("fileUploadIcon");
    fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

    var fileUploadHeader = document.getElementById("fileUploadHeader");
    fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
  }


  const onDrop = useCallback((e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      if (files.length > 1) {
        setError('Please drop only one image file (e.g., .jpg, .png)');

        var fileUploadIcon = document.getElementById("fileUploadIcon");
        fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

        var fileUploadHeader = document.getElementById("fileUploadHeader");
        fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
      } else {
        const droppedFile = files[0];

        if (droppedFile.type.startsWith('image/')) {
          const maxSize = 20 * 1024 * 1024; // 20MB

          if (droppedFile.size > maxSize) {
            setError('Please drop an image file less than 5MB');

            var fileUploadIcon = document.getElementById("fileUploadIcon");
            fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

            var fileUploadHeader = document.getElementById("fileUploadHeader");
            fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
          } else {
            setCustBgImgFile(droppedFile);
            setError('');

            var fileUploadIcon = document.getElementById("fileUploadIcon");
            fileUploadIcon.innerHTML = "<i class='fa-solid fa-circle-check'></i>";

            var fileUploadHeader = document.getElementById("fileUploadHeader");
            fileUploadHeader.innerHTML = 'File Dropped Successfully!';
          }
        } else {
          setError('Please drop an image file (e.g., .jpg, .png)');

          var fileUploadIcon = document.getElementById("fileUploadIcon");
          fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

          var fileUploadHeader = document.getElementById("fileUploadHeader");
          fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
        }
      }
    }
  }, []);

  const handlePromptChange = (e) => {
    setPrompt(e.target.value);
  }

  // const handleEnvBgImgClick = (imageUrl, imgName, imgId) => {
  //   setSelectedEnvBg({
  //     img_Id: imgId,
  //     Img_Name: imgName,
  //     Img_Url: imageUrl
  //   });
  // };

  const handleEnvBgImgClick = (imageUrl, imgName, imgId) => {
    setSelectedEnvBg({
      img_Id: imgId,
      Img_Name: imgName,
      Img_Url: imageUrl
    });

    if (imageUrl === "") {
      setError('Please select an image');
      return;
    }

    setCustBgImgFile(null);
    setError('');

    setCustEnvImgPreview(imageUrl);

    var img = document.getElementById("custEnvImgPreview");
    img.style.visibility = "visible";
    img.style.width = "100%";
    img.style.height = "auto";

    setChoosedEnvBg({
      img_Id: imgId,
      Img_Name: imgName,
      Img_Url: imageUrl
    });
    const closeButton = document.querySelector('#EnvBgImgLibraryModal [data-bs-dismiss="modal"]');
    if (closeButton) {
      closeButton.click();
    }
  };


  return (
    <>
      <div className="page-content-wrapper">

        {/* Custom Background Upload Modal */}
        <div class="modal fade" style={{ top: "30px", left: "25px" }} id="uploadImageModal" tabindex="-1" aria-labelledby="uploadImageModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-fullscreen" style={{ width: "98%", height: "95%" }}>
            <div class="modal-content" style={{ paddingRight: "10px" }}>
              <div class={(custBgLimit && custBgRemaining) ? "modal-header row" : "modal-header"}>
                {custBgLimit && custBgRemaining &&
                  <div className="d-flex justify-content-center">
                    <span style={{ color: "#1e2e38", fontSize: "18px", fontWeight: "600" }}>Limit: {custBgRemaining} / {custBgLimit}</span>
                  </div>
                }
                <div class="d-flex justify-content-between align-items-center">
                  <h1 class="modal-title fs-5" style={{ margin: "0", marginLeft: "10px", fontWeight: "600" }} id="uploadImageModalLabel">Upload Custom Environment Background</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

              </div>
              <div class="modal-body">
                <div className="row d-flex justify-content-center">
                  <div className="col-sm-2">
                    <h4 style={{ textAlign: "end", margin: "0px", marginTop: "5px", fontWeight: "500" }}>Prompt : </h4>
                  </div>
                  <div className="col-sm-4">
                    <input
                      type="text"
                      value={prompt}
                      onChange={handlePromptChange}
                      name="prompt"
                      className="form-control"
                      id="prompt"
                      disabled={(isEnvGenerating || generatedImages.length > 0)}
                      placeholder="make it more realistic with good lighting"
                    />
                  </div>
                </div>
                <hr style={{ height: "2px", background: "#711a1a73" }} />
                <div className="row d-flex justify-content-center">

                  {isEnvGenerating &&
                    <>
                      {/* Loading Animation Starts */}
                      <div className="col-sm-6 d-flex justify-content-center" style={{ marginTop: "150px" }}>
                        <div class="device" style={{ fontSize: "30px" }}>
                          <div class="device__a" style={{ backgroundColor: "#abafba" }}>
                            <div class="device__a-1" style={{ backgroundColor: "#000" }}></div>
                            <div class="device__a-2" style={{ backgroundColor: "#000" }}></div>
                          </div>
                          <div class="device__b" style={{ backgroundColor: "#000" }}></div>
                          <div class="device__c" style={{ backgroundColor: "#000" }}></div>
                          <div class="device__d" style={{ backgroundColor: "#abafba" }}></div>
                          <div class="device__e" style={{ backgroundColor: "#abafba" }}></div>
                          <div class="device__f" style={{ backgroundColor: "#abafba" }}></div>
                          <div class="device__g" style={{ backgroundColor: "#abafba" }}></div>
                        </div>
                      </div>
                      {/* Loading Animation Ends */}
                    </>
                  }

                  {(!isEnvGenerating && generatedImages.length < 1) &&
                    <>

                      <div className="col-sm-6">
                        {error && <h4 style={{ textAlign: "center", margin: "0px", marginTop: "5px 0 20px 0", fontWeight: "500", color: "red" }}>{error}</h4>}

                        <div
                          class="drag-area"
                          style={{ paddingBottom: "30px", paddingTop: "50px" }}
                          onDragOver={onDragOver}
                          onDrop={onDrop}
                          onDragEnter={onDragOver}
                          onDragLeave={onDragLeave}>
                          <div id="fileUploadIcon"><i class="fa-solid fa-upload"></i></div>
                          <header id="fileUploadHeader">Drag & Drop to Upload File</header>
                          <span>OR</span>
                          <label htmlFor="customBgImg" style={{ cursor: 'pointer' }}>Select an image</label>
                          <input
                            type="file"
                            onChange={onCustBgImgUpload}
                            id="customBgImg"
                            name="customBgImg"
                            accept="image/*"
                            hidden />
                        </div>
                      </div>
                      <div className="row row d-flex justify-content-center">
                        <div className="col-sm-6">
                          <div className="d-flex justify-content-center">
                            {
                              custBgImgFile &&
                              <h4
                                style={{ textAlign: "center", margin: "0px", marginTop: "20px", fontWeight: "500", color: "#000", backgroundColor: "#ffc63e", padding: "5px 20px 5px 20px", borderRadius: "50px" }}>
                                <span>{custBgImgFile.name}</span>
                                <span style={{ marginLeft: "10px", marginRight: "10px" }}> | </span>
                                <span>{(custBgImgFile.size / (1024 * 1024)).toFixed(2)} MB</span>
                                <span onClick={removeFileButton} style={{ marginLeft: "50px", cursor: "pointer" }}><i class="fa-solid fa-trash"></i></span>
                              </h4>}
                          </div>

                          <div className="mt-5">
                            <ul>
                              <li>
                                <span style={{ fontStyle: "italic" }}>Make sure the uploaded image resembles the selected <b>Environment</b>.</span>
                              </li>
                              <li>
                                <span style={{ fontStyle: "italic" }}>Enter specific prompts in the <b>Prompt</b> field to get the desired background.</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  }

                </div>

                {(!isEnvGenerating && generatedImages.length > 0) &&
                  <>
                    <div className="row d-flex justify-content-center">
                      {generatedImages.map((imageUrl, index) => (
                        <div className="col-sm-5 my-2" key={index}>
                          <img
                            src={imageUrl}
                            onClick={() => handleEnvBgImgClick(imageUrl, "", 0)}

                            style={{
                              width: "100%",
                              height: "auto",
                              cursor: "pointer",
                              margin: "5px",
                              borderRadius: "5px",
                              border: selectedEnvBg.Img_Url === imageUrl ? "7px solid #ffc63e" : "1px solid #ccc",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </>
                }

              </div>
              <div class="modal-footer">
                {!isEnvGenerating && generatedImages.length < 1 &&
                  <>
                    {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                    <button type="button" onClick={onUploadClicked} class="btn" style={{ backgroundColor: "#1e2e38", color: "#FFF" }}>Upload</button>
                  </>
                }

                {!isEnvGenerating && generatedImages.length > 0 &&
                  <>
                    <button type="button" onClick={onCancelClicked} data-bs-dismiss="modal" class="btn btn-secondary">Cancel</button>
                    <button type="button" onClick={onChooseClicked} disabled={!selectedEnvBg.Img_Url} data-bs-dismiss="modal" class="btn" style={{ backgroundColor: "#1e2e38", color: "#FFF" }}>Choose</button>
                  </>
                }
              </div>
            </div>
          </div>
        </div>
        {/* Custom Background Modal Ends */}



        {/* Environment Background Images Library Modal Ends */}
        <div class="modal fade" id="EnvBgImgLibraryModal" tabindex="-1" aria-labelledby="EnvBgImgLibraryModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content" style={{ paddingRight: "20px" }}>
              <div className="modal-header">
                <div class="d-flex justify-content-between align-items-center w-100">
                  <h1 class="modal-title fs-5" style={{ margin: "0", marginLeft: "10px", fontWeight: "600" }} id="EnvBgImgLibraryModalLabel">Environment Library</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
              </div>
              <div class="modal-body">
                <div className="row d-flex justify-content-center">
                  {EnvBgImgList.map((imgData, index) => (
                    <div className="col-sm-5 my-2" key={index}>
                      <img
                        src={imgData.img_Url}
                        onDoubleClick={() => handleEnvBgImgClick(imgData.img_Url, imgData.img_Name, imgData.img_Id)}

                        style={{
                          width: "100%",
                          height: "auto",
                          cursor: "pointer",
                          margin: "5px",
                          borderRadius: "5px",
                          border: selectedEnvBg.Img_Url === imgData.img_Url ? "7px solid #ffc63e" : "1px solid #ccc",
                        }}
                      />
                    </div>
                  ))}
                </div>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                {/* <button type="button" onClick={onChooseClicked} disabled={!selectedEnvBg.Img_Url} data-bs-dismiss="modal" class="btn" style={{ backgroundColor: "#1e2e38", color: "#FFF" }}>Choose</button> */}
              </div>
            </div>
          </div>
        </div>
        {/* Environment Background Images Library Modal Ends */}




        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">Add Case</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn d-inline-block"
                  style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-2 col-sm-2"></div>
            <div className="col-md-8 col-sm-8">
              <div className="card card-box">
                <div className="card-head">
                  <header>Add Case</header>
                </div>
                <div className="card-body " id="bar-parent1">
                  <form
                    className="register-form"
                    id="login-form"
                    onSubmit={Patientsubmit}
                  >
                    <div className="form-group row">
                      <label
                        className="col-sm-3 control-label"
                      >
                        Case ID{" "}
                      </label>
                      <div className="col-sm-9 pt-2">
                        <p>{LastPatientId}</p>
                      </div>
                    </div>

                    {/* Case Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="caseName"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Case Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={CaseName}
                          onChange={handleChangeCaseName}
                          name="caseName"
                          className="form-control"
                          id="caseName"
                          placeholder="Enter the name of your case "
                        />
                      </div>
                    </div>

                    {/* Case Description */}
                    {/* <div className="form-group row">
                      <label
                        htmlFor="caseDescription"
                        className="col-sm-3 control-label"
                      >
                        Case Description
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={CaseDescription}
                          onChange={handleChangeCaseDescription}
                          name="caseDescription"
                          className="form-control"
                          id="caseDescription"
                          placeholder="Enter Case Description"
                        />
                      </div>
                    </div> */}

                    {/* Patient Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="PatientName"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={PatientName}
                          onChange={handleChangePatientName}
                          name="patientName"
                          className="form-control"
                          id="PatientName"
                          placeholder="Enter the name of your virtual character "
                        />
                      </div>
                    </div>

                    {/* Patient Date of Birth */}
                    <div className="form-group row required">
                      <label
                        htmlFor="PatientDOB"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character’s Date of Birth
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="date"
                          value={DateOfBirth}
                          onChange={handleChangePatientAge}
                          name="patientDOB"
                          className="form-control"
                          id="PatientDOB"
                          max={new Date()?.toISOString()?.slice(0, 10)}
                          placeholder="Enter DOB"
                        />
                      </div>
                    </div>

                    {/* Gender */}
                    <div className="form-group row required">
                      <label
                        htmlFor="gender"
                        className="col-sm-3 control-label"
                      >
                        Gender
                      </label>
                      <div className="col-sm-9">
                        <select
                          id="gender"
                          className="form-control  select2"
                          value={Gender}
                          onChange={handleChangeGender}
                        >
                          <option value="">Select the gender of the virtual character </option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="NonBinary">Non Binary</option>
                        </select>
                      </div>
                    </div>

                    {/* Character Role */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Role"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character's Role
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={PatientRole}
                          onChange={handleChangePatientRole}
                          name="role"
                          className="form-control"
                          id="Role"
                          placeholder="Enter the role of the virtual character "
                        />
                      </div>
                    </div>

                    {/* User Role */}
                    <div className="form-group row required">
                      <label
                        htmlFor="UserRole"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        User's Role
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={UserRole}
                          onChange={handleChangeUserRole}
                          name="userRole"
                          className="form-control"
                          id="UserRole"
                          placeholder="Enter the role of the user/learner "
                        />
                      </div>
                    </div>

                    {/* Address */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Address"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character’s Address
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={Address}
                          onChange={handleChangeAddress}
                          name="address"
                          className="form-control"
                          id="Address"
                          placeholder="Enter the residential address of the virtual character "
                        />
                      </div>
                    </div>

                    {/* Place of Occurrence */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Place"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Scenario location
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={Place}
                          onChange={handleChangePlace}
                          name="place"
                          className="form-control"
                          id="Place"
                          placeholder="Enter the location where the scenario is being taking place "
                        />
                      </div>
                    </div>

                    {/* Personal Life */}
                    <div className="form-group row required">
                      <label
                        htmlFor="personalLife"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Virtual Character's Personal Life
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          value={PersonalLife}
                          onChange={handleChangePersonalLife}
                          name="personalLife"
                          className="form-control"
                          id="personalLife"
                          style={{ width: "100%", height: "100px" }}
                          placeholder="Enter details about the virtual character’s personal life, e.g., married, children, occupation, family members etc "
                        />
                      </div>
                    </div>

                    {/* Presenting Problem */}
                    <div className="form-group row required">
                      <label
                        htmlFor="presenting_problem"
                        className="col-sm-3 control-label"
                      >
                        Case Description
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          id="presenting_problem"
                          className="form-control"
                          name="presentingProblem"
                          style={{ width: "100%", height: "100px" }}
                          value={PresentingProblem}
                          onChange={handleChangePresentingProblem}
                          placeholder="Enter details about the case, e.g., what is the issue, what is the problem, what is the subject of conversation. "
                        />
                      </div>
                    </div>

                    <div className="form-group my-5">
                      <span className="fw-bolder">Watch this video before proceeding to generate your own background.</span>
                      <a href="https://vimeo.com/993876527/07a352df34" target="_blank" className="ms-5 btn" style={{ backgroundColor: "#1b2e36", color: "#FFF" }}>
                        Click to watch
                      </a>
                    </div>

                    <div className="form-group row required">
                      <label
                        htmlFor="environment"
                        className="col-sm-3 control-label"
                      >
                        Environment
                        <img id="infoToolTip" style={{ width: "22px", paddingLeft: "3px", paddingRight: "3px", paddingBottom: "3px" }} src={infoIcon} />

                        <p>
                          This includes the overall setup of the scene. It is a combination of the physical content (e.g table, counters) and the background.
                        </p>
                      </label>
                      <div className="col-sm-4">
                        <select
                          id="environment"
                          className="form-control select2"
                          onChange={handleChangeEnvironment}
                        >
                          <option value="">--Select--</option>
                          {EnvironmentList.map((result, i) => {
                            return (
                              <option value={result.id} key={result.id}>
                                {result.environment_Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="col-sm-5">
                        <div className="col-sm-12 d-flex justify-content-center">
                          <a href={EnvironmentImgPreview} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                              id="envImgPreview"
                              className="previewImg"
                              src={EnvironmentImgPreview}
                              style={{
                                objectFit: "contain",
                                visibility: "hidden"
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>


                    {/* Custom Background Starts */}
                    <div className="form-group row">
                      <label
                        htmlFor="customEnvBg"
                        className="col-sm-3 control-label"
                      >
                        Custom Background
                        <img id="infoToolTipCB" style={{ width: "22px", paddingLeft: "3px", paddingRight: "3px", paddingBottom: "3px" }} src={infoIcon} />

                        <p>
                          Contains only the backdrop of the <b>Environment</b>. Will appear behind the physical content of the selected <b>Environment</b>.
                        </p>
                      </label>
                      <div className="col-sm-4">
                        <div className="row mb-3 ms-0 me-0">
                          <button type="button" class="btn col-12" style={{ color: "#FFF", backgroundColor: "#1b2e36" }} data-bs-toggle="modal" data-bs-target="#uploadImageModal">
                            Upload Image
                          </button>

                          {EnvBgImgList.length > 0 &&
                            <button type="button" class="btn btn-secondary col-12 mt-3" data-bs-toggle="modal" data-bs-target="#EnvBgImgLibraryModal">
                              Custom Background Library
                            </button>
                          }

                          {CustEnvImgPreview &&
                            <button type="button" class="btn col-12 mt-3" style={{ backgroundColor: "#ffc63e", color: "#000" }} onClick={onRemoveClicked}>
                              Clear Custom Background
                            </button>
                          }

                          {CustEnvImgPreview &&
                            <div className="col-12 ps-0 pe-0 mt-3">
                              <input
                                type="text"
                                placeholder="Enter image name"
                                className="form-control"
                                value={choosedEnvBg.Img_Name}
                                onChange={handleChangeEnvBgImgName} />
                            </div>
                          }

                          {!EnvironmentId &&
                            <>
                              <span className="col-12 mt-2 ps-0 pe-0"><i>You must select a reference <b>Environment</b> before uploading an image.</i></span>
                            </>
                          }
                        </div>
                      </div>

                      <div className="col-sm-5">
                        <div className="col-sm-12 d-flex justify-content-center">
                          <a href={CustEnvImgPreview} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                              id="custEnvImgPreview"
                              className="previewImg"
                              src={CustEnvImgPreview}
                              style={{
                                objectFit: "contain",
                                visibility: "hidden"
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                    {/* Custom Background Ends */}





                    <div className="form-group row required mt-3">
                      <label
                        htmlFor="character"
                        className="col-sm-3 control-label"
                      >
                        Character
                      </label>
                      <div className="col-sm-4">
                        <select
                          id="character"
                          className="form-control select2"
                          onChange={handleChangeCharacter}
                        >
                          <option value="">--Select--</option>
                          {CharacterList.map((result, i) => {
                            return (
                              <option value={result.id} key={result.id}>
                                {result.character_Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="col-sm-5">
                        <div className="col-sm-12 d-flex justify-content-center">
                          <a href={CharacterImgPreview} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                              id="characterImgPreview"
                              className="previewImg"
                              src={CharacterImgPreview}
                              style={{
                                objectFit: "contain",
                                visibility: "hidden"
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Custom Voice ID List */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Voice"
                        className="col-sm-3 control-label"
                      >
                        Character's Voice
                      </label>
                      <div className="col-sm-9">
                        <select
                          id="Voice"
                          className="form-control select2"
                          onChange={handleChangeVoice}
                        >
                          <option value="">--Select--</option>
                          {VoiceList.map((result, i) => {
                            return (
                              <option value={result.id} key={result.id}>
                                {result.voice_Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    <div className="form-group my-5">
                      <span className="fw-bolder">Watch this video to know more about Assessment Blueprint.</span>
                      <a href="https://vimeo.com/998113386" target="_blank" className="ms-5 btn" style={{ backgroundColor: "#1b2e36", color: "#FFF" }}>
                        Click to watch
                      </a>
                    </div>

                    {/* Assessment Blueprint */}
                    <div className="form-group row required">
                      <label
                        htmlFor="assessmentBlueprint"
                        className="col-sm-3 control-label"
                      >
                        Assessment Blueprint
                      </label>
                      <div className="col-sm-9">
                        <div className="row">
                          <div className="col-sm-4">
                            <input type="text" placeholder="Skill name" className="form-control" value={Skill1} onChange={handleChangeSkill1} />
                          </div>
                          <div className="col-sm-8">
                            <input type="text" placeholder="Enter the description of the competency being assessed. " className="form-control" value={SkillDesc1} onChange={handleChangeSkillDesc1} />
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" value={Skill2} onChange={handleChangeSkill2} />
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed. " className="form-control" value={SkillDesc2} onChange={handleChangeSkillDesc2} />
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" value={Skill3} onChange={handleChangeSkill3} />
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed. " className="form-control" value={SkillDesc3} onChange={handleChangeSkillDesc3} />
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" value={Skill4} onChange={handleChangeSkill4} />
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed. " className="form-control" value={SkillDesc4} onChange={handleChangeSkillDesc4} />
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" value={Skill5} onChange={handleChangeSkill5} />
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed. " className="form-control" value={SkillDesc5} onChange={handleChangeSkillDesc5} />
                          </div>

                          <div className="col-sm-4 mt-3 d-none">
                            <input type="text" placeholder="Skill name" className="form-control" value={Skill6} onChange={handleChangeSkill6} />
                          </div>
                          <div className="col-sm-8 mt-3 d-none">
                            <input type="text" placeholder="Enter the description of the competency being assessed. " className="form-control" value={SkillDesc6} onChange={handleChangeSkillDesc6} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr style={{ height: "2px", color: "#000", marginTop: "30px", marginBottom: "10px" }} />
                    <h4 style={{ textAlign: "center", marginTop: "0", marginBottom: "20px", fontWeight: "800" }}>Additional Details</h4>

                    {/* About The Case */}
                    <div className="form-group row required">
                      <label
                        htmlFor="AboutTheCase"
                        className="col-sm-3 control-label"
                      >
                        About The Case
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          id="AboutTheCase"
                          className="form-control"
                          name="AboutTheCase"
                          style={{ width: "100%", height: "100px" }}
                          value={AboutTheCase}
                          onChange={handleChangeAboutTheCase}
                          placeholder="About the case ... "
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 text-end">

                        {!isFinalSubmitting &&
                          <button
                            type="submit"
                            className="btn d-inline-block"
                            style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                          >
                            Submit
                          </button>
                        }

                        {isFinalSubmitting &&
                          <button
                            class="btn d-inline-block"
                            type="button"
                            style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                            disabled>
                            <span class="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                            <span role="status">Submitting...</span>
                          </button>
                        }
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddManagerPatient;
